import { addLocale, useLocale } from 'ttag';

(async () => {
  const languageCode = window?.config?.language_code;

  if (!languageCode || languageCode !== 'en') {
    const ttagTranslation = await import(`../locale/${languageCode}.po.json`);

    addLocale(languageCode, ttagTranslation);
    useLocale(languageCode);
  }
})();

async function loadTranslations() {
  const languageCode = window?.config?.language_code || 'da';

  if (!languageCode || languageCode !== 'en') {
    const ttagTranslation = await import(`../locale/${languageCode}.po.json`);

    addLocale(languageCode, ttagTranslation);
    useLocale(languageCode);
  }
}

export default loadTranslations;
